import _ from 'lodash'

import { POC_MNG } from '@/api/apiModules'
import lang from '@/lang'
export default {
  viewType: 'form',
  module: POC_MNG,
  needFetchFillInfo: false,
  params: null,
  formatData(data) {
    //模版项目id
    data.templateProjectId = data.templateProjectLabel.id
    data.salesId = data.salesIdLabel.id
    data.presalesId = data.presalesIdLabel.id
    data.postsalesIdList = []
    data.postsalesIdLabelList.forEach(element => {
      data.postsalesIdList.push(element.id)
    })
    data.extensionIdList = []
    data.extensionIdLabelList?.forEach(element => {
      data.extensionIdList.push(element.id)
    })
    data.postsalesLeaderList = []
    data.postsalesLeaderLabelList?.forEach(element => {
      data.postsalesLeaderList.push(element.id)
    })

    var list = []

    if (data.envRelateSceneArr) {
      data.envRelateSceneList = data.envRelateSceneArr.map(item => {
        list.indexOf(item.collectReportId) == -1 ? list.push(item.collectReportId) : ''
        return {
          collectReportId: item.envData.id,
          sceneId: item.scene
        }
      })
      if (list.length < data.envRelateSceneArr) {
        this.dispatch('OpenNotification', {
          message: '选中的场景报告中，包含两个一样的报告',
          type: 'error'
        })
        return
      }
    }
    if (data.customer) {
      data.customer = data.customer.trim()
    }
    if (data.projectName) {
      data.projectName = data.projectName.trim()
    }
    if (data.crmOrderId) {
      data.crmOrderId = data.crmOrderId.trim()
    }
    return data
  },
  view: {
    title: 'pocMng.createBasePocProject',
    labelPosition: 'right',
    labelWidth: '165px',
    width: '650px',
    content: [
      {
        $id: 'industryId',
        $type: 'radio-button',
        label: 'pocMng.industry',
        $default: null,
        params: {
          unPage: true
        },
        $el: {
          class: 'wsp-custom-edit-industry-disabled',
          disabled: true
        },
        $options: [],
        rules: [
          {
            notEmpty: 'pocMng.industryEmpty'
          }
        ],
        actions: {
          on: {
            updateValue: 'autoFillIndustry'
          }
        }
      },
      {
        $id: 'projectArea',
        $type: 'select',
        label: 'pocMng.projectArea',
        $el: {
          clearable: true
        },
        $options: 'global/enum/area',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.label,
              label: item.label
            }
          })
          return value ? value : ''
        },
        rules: [{ notEmpty: { message: 'pocMng.projectAreaEmpty' } }],
        actions: {
          on: {
            updateValue: 'autoFillArea'
          }
        }
      },
      {
        $id: 'projectName',
        $type: 'input',
        label: '项目名称',
        rules: [
          {
            notEmpty: '项目名称'
          }
        ]
      },
      {
        $id: 'customer',
        $type: 'input',
        label: 'pocMng.customer',
        rules: [
          {
            notEmpty: 'pocMng.customer'
          }
        ]
      },
      {
        $id: 'salesIdLabel',
        $type: 'sky-relation-option',
        label: 'pocMng.sales',
        $el: { disabled: false, multiple: false },

        actions: {
          nativeOn: {
            click: 'UmRelationUser'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.salesEmpty' } }]
      },
      {
        $id: 'presalesIdLabel',
        $type: 'sky-relation-option',
        label: 'pocMng.presales',
        $el: { disabled: false },
        actions: {
          nativeOn: {
            click: 'UmRelationUser'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.presalesEmpty' } }]
      },
      {
        $id: 'postsalesIdLabelList',
        $type: 'sky-relation-option',
        label: 'pocMng.postsales',
        $el: { disabled: false, multiple: true },
        actions: {
          nativeOn: {
            click: 'UmRelationUserList'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.postsalesEmpty' } }]
      },
      {
        $id: 'postsalesLeaderLabelList',
        $type: 'sky-relation-option',
        label: 'pocMng.postsalesLeaderIds',
        $el: { disabled: false, multiple: true },
        actions: {
          nativeOn: {
            click: 'UmRelationUserList'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.postsalesLeaderEmpty' } }]
      },
      {
        $id: 'extensionIdLabelList',
        $type: 'sky-relation-option',
        label: 'pocMng.extensionIds',
        $el: { disabled: false, multiple: true },
        actions: {
          nativeOn: {
            click: 'UmRelationUserList'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.extensionEmpty' } }]
      },
      {
        $id: 'enablePc', //是否是利旧PC 项目
        $type: 'switch',
        label: 'pocMng.enablePC',
        tip: {
          description: ['pocMng.tips.enablePC']
        },
        $default: false
      },
      {
        $id: 'enableProduct',
        $type: 'switch',
        label: 'pocMng.enableProduct',
        $default: false
      },
      {
        $id: 'professionalWinningProject',
        $type: 'switch',
        label: 'pocMng.professionalWinningProject',
        $default: false
      },
      {
        $id: 'winProjectApplyLink',
        $type: 'sky-win-url-link',
        $enableWhen: {
          professionalWinningProject: function(currentValue, data, meta) {
            if (currentValue) {
              return true
            }
          }
        }
      },
      {
        $id: 'crmOrderId',
        $type: 'input',
        label: 'pocMng.crmOrderId',
        rules: [
          {
            notEmpty: 'pocMng.crmOrderId'
          }
        ]
      },
      {
        $id: 'projectType',
        $type: 'select',
        label: 'pocMng.projectType',
        // $default: '',
        $el: {
          filterable: true,
          multiple: false
        },
        $options: [],
        // $options: 'global/enum/projectType',
        // dataType: 'asyn',
        // format: function(meta, value) {
        //   const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
        //   meta.$options = _options.map(item => {
        //     return {
        //       value: item.id,
        //       label: item.label
        //     }
        //   })
        //   return value ? value : ''
        // },
        rules: [
          {
            notEmpty: 'pocMng.projectTypeEmpty'
          }
        ]
      },
      {
        $id: 'projectBackground',
        $type: 'input',
        label: 'pocMng.projectBackground',
        $el: {
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: 'pocMng.projectBackground'
          }
        ]
      },
      {
        $id: 'projectRequest',
        $type: 'input',
        label: 'pocMng.projectRequest',
        tip: {
          description: ['pocMng.tips.projectRequest']
        },
        $el: {
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: 'pocMng.projectRequest'
          }
        ]
      },
      {
        $id: 'templateDownload',
        $type: 'sky-url-link'
      },
      {
        $id: 'startTime',
        $type: 'datePicker',
        $el: {
          type: 'date',
          style: 'width: 100%'
        },
        label: 'pocMng.startTime',
        rules: [
          {
            notEmpty: 'pocMng.startTimeEmpty'
          }
        ]
      },
      {
        $id: 'projectCycle',
        $type: 'input-number',
        label: 'pocMng.testCycle',
        $el: {
          min: 0
        },
        rules: [
          {
            notEmpty: 'pocMng.testCycleEmpty'
          }
        ]
      },
      {
        $id: 'testModeArr',
        $type: 'select',
        label: 'pocMng.testMode',
        $default: [],
        $el: {
          filterable: true,
          multiple: true
        },
        $options: [
          {
            label: '功能测试',
            id: 'FUNCTION_TEST'
          },
          {
            label: '性能测试',
            id: 'PERFORMANCE_TEST'
          },
          {
            label: '体验测试',
            id: 'EXPERIENCE_TEST'
          }
        ],
        rules: [
          {
            notEmpty: 'pocMng.testModeEmpty'
          }
        ]
      },
      {
        $id: 'competitorArr',
        $type: 'select',
        label: 'pocMng.competitor',
        $default: [],
        $el: {
          filterable: true,
          multiple: true
        },
        $options: [
          {
            value: 'HUAWEI',
            label: '华为'
          },
          {
            value: 'SANGFOR',
            label: '深信服'
          },
          {
            value: 'H3C',
            label: 'H3C'
          },
          {
            value: 'OS_EASY',
            label: '噢易'
          },
          {
            value: 'KD_MASTER',
            label: '铠大师'
          },
          {
            value: 'CAI_HONG',
            label: '彩虹'
          },
          {
            value: 'SKY_WORTH',
            label: '创维'
          }
        ],
        rules: []
      },
      {
        $id: 'otherCompetitors',
        $type: 'input',
        label: 'pocMng.otherCompetitor',
        $el: {
          placeholder: lang.t('pocMng.otherCompetitorPlaceholder')
        }
      }
    ]
  }
}
